import { render, staticRenderFns } from "./CreatorDetailTabs.vue?vue&type=template&id=95ece8d0"
import script from "./CreatorDetailTabs.vue?vue&type=script&lang=js"
export * from "./CreatorDetailTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports